import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getEmployees = createAsyncThunk(
  'employees/getEmployees',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/organisations/users`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const assumeEmployeeRole = createAsyncThunk(
  'employees/assumeEmployeeRole',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/become`, {
        user: { user_id: id },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const unlinkEmployees = createAsyncThunk(
  'employees/unlinkEmployees',
  async ({ users }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/users/unlink`, {
        users,
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
